export default __webpack_public_path__ + "static/media/logo-carto-1.f9c4466b.png";